// styles.ts
import styled from "styled-components";

/**
 * Estilização para o esqueleto do card de voo.
 */
export const StyledFlightCardSkeleton = styled.div`
  background-color: #ffffff;
  display: flex;
  width: 100%;
  height: 160px;
  flex-direction: row;
  margin-top: 20px;
  border-radius: 12px;
`;

/**
 * Estilização para a seção esquerda do esqueleto do card de voo.
 */
export const StyledFlightCardSkeletonLeft = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isMobile"].includes(prop as string),
})<{ isMobile?: boolean }>`
  display: flex;
  width: ${({ isMobile }) => (isMobile ? "65%" : "75%")};
  height: 100%;
  flex-direction: column;
`;

/**
 * Estilização para os itens dentro da seção esquerda do esqueleto.
 */
export const StyledFlightCardSkeletonLeftItem = styled.div`
  display: flex;
  width: 100%;
  height: 50%;
  align-items: center;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
`;

/**
 * Estilização para a seção direita do esqueleto do card de voo.
 */
export const StyledFlightCardSkeletonRight = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isMobile"].includes(prop as string),
})<{ isMobile?: boolean }>`
  background-color: #d6d6d64e;
  display: flex;
  width: ${({ isMobile }) => (isMobile ? "35%" : "25%")};
  height: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
`;

/**
 * Estilização para a container de paginação.
 */
export const StyledPaginationContainerCards = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isMobile"].includes(prop as string),
})<{ isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${({ isMobile }) =>
    isMobile &&
    `
    grid-column: 1 / -1;
  `}
`;
